import { render, staticRenderFns } from "./PositionSwitcher.vue?vue&type=template&id=74ecfe34&scoped=true"
import script from "./PositionSwitcher.vue?vue&type=script&lang=js"
export * from "./PositionSwitcher.vue?vue&type=script&lang=js"
import style0 from "./PositionSwitcher.vue?vue&type=style&index=0&id=74ecfe34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ecfe34",
  null
  
)

export default component.exports